export default "__VITE_ASSET__tBxr0BbH__"